import { render, staticRenderFns } from "./net-banking.vue?vue&type=template&id=fbf99c0e&scoped=true"
import script from "./net-banking.vue?vue&type=script&lang=js"
export * from "./net-banking.vue?vue&type=script&lang=js"
import style0 from "./net-banking.vue?vue&type=style&index=0&id=fbf99c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf99c0e",
  null
  
)

export default component.exports